import {CustomerDTO} from "@/api/Customer";

export default class CustomerEmail{
    public email = "";

    constructor(dto?: CustomerDTO) {
        if(dto) {
            this.email = dto.email;
        }
    }
}